import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { ProductGroupService } from 'src/app/Service/ProductGroup/ProductGroup.service';

@Component({
  selector: 'app-ProductGroupAdd',
  templateUrl: './ProductGroupAdd.component.html',
  styleUrls: ['./ProductGroupAdd.component.css']
})
export class ProductGroupAddComponent implements OnInit {

  Token:String=""

  constructor(
    private ProductGroup_Service:ProductGroupService,
    private Nav_Service:NavService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

    this.AddNewProductGroup=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null,Validators.required),
    })


    this.Nav_Service.CheckValidPage(this.Token,2206).subscribe(
      data=>{
        
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }


  //#region  Form Add

  AddNewProductGroup:FormGroup;

  get_Form_Title(){
    return this.AddNewProductGroup.get('Title') as FormControl;
  }

  //#endregion

  InProccessing:boolean=false

  SubmitAddNewProductGroup(){
    var Record:General_Interface =Empty_General_Interface()
    Record.id=0
    Record.title=this.get_Form_Title().value
    this.InProccessing=true
    this.ProductGroup_Service.AddProductGroup(Record,this.Token).subscribe(
      data=>{
        this.InProccessing=false
        if(data.id==-2){
          this.Alertify_Service.ErrorMessage("The entered title already exists in the list.")
        }
        else{
          this.AddNewProductGroup.reset()
          this.Alertify_Service.SuccessMessage("Information saved successfully.")
        }
      },error=>{
        localStorage.clear()
        location.reload();
        
      }
    )
  }

}
